// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProjectFilledSvg from "@fishx/icons-svg/es/asn/ProjectFilled";
import FishxIcon from '../components/FishxIcon';

var ProjectFilled = function ProjectFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ProjectFilledSvg
  }));
};

ProjectFilled.displayName = 'ProjectFilled';
export default React.forwardRef(ProjectFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ProjectFilled.js
// module id = 3856
// module chunks = 0